import { Dialog } from "@dash/dialog";
import { Button, TextField } from "@dash/form";
import { useTheme } from "@emotion/react";
import { useState } from "react";
import type { FC } from "react";

type Props = {
  productLabel: string;
  serialNumber: string | null;
  isDisabled?: boolean;
  onRemove: () => void;
  onSerialChange: (value: string) => void;
};

export const SupportTicketProductChip: FC<Props> = ({
  productLabel,
  serialNumber,
  isDisabled,
  onRemove,
  onSerialChange,
}) => {
  const theme = useTheme();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [draft, setDraft] = useState(serialNumber ?? "");

  const openDialog = () => {
    if (isDisabled) return;
    setDraft(serialNumber ?? "");
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setDraft(serialNumber ?? "");
    setIsDialogOpen(false);
  };

  const saveSerial = () => {
    onSerialChange(draft.trim());
    setIsDialogOpen(false);
  };

  const removeProduct = () => {
    onRemove();
    setIsDialogOpen(false);
  };

  const label = serialNumber ? `${productLabel} ${serialNumber}` : productLabel;

  return (
    <>
      <button
        type="button"
        disabled={isDisabled}
        onClick={openDialog}
        css={{
          background: theme.colors.primaryLight,
          border: "none",
          borderRadius: theme.smallBorderRadius,
          padding: "5px 10px",
          font: "inherit",
          fontSize: "0.875rem",
          fontWeight: 500,
          color: theme.colors.primary,
          whiteSpace: "nowrap",
          cursor: isDisabled ? "not-allowed" : "pointer",
          textDecoration: "none",
          ":hover": {
            textDecoration: isDisabled ? "none" : "underline",
          },
        }}
      >
        {label}
      </button>
      {isDialogOpen && (
        <Dialog header={productLabel} onClose={closeDialog} css={{ width: "22rem" }}>
          <div css={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            <TextField
              label="Numer seryjny (opcjonalny)"
              value={draft}
              onChange={setDraft}
              autoFocus
            />
            <div css={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
              <Button variant="text" onClick={closeDialog}>
                Anuluj
              </Button>
              <Button
                onClick={removeProduct}
                css={{
                  background: theme.colors.danger,
                  color: "#fff",
                  border: "none",
                  ":hover": {
                    textDecoration: "none",
                    opacity: 0.9,
                  },
                }}
              >
                Usuń
              </Button>
              <Button onClick={saveSerial}>Zapisz</Button>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
};
